import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=61fc3834&scoped=true&"
import script from "./PeopleSearch.vue?vue&type=script&lang=js&"
export * from "./PeopleSearch.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSearch.vue?vue&type=style&index=0&id=61fc3834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc3834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItem,VListItemAvatar,VListItemTitle})
